import { Button, Typography } from '@mui/material';
import { StyledCenterBox } from '../Home.styled';
import HomeSection from '../HomeSection';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import React from 'react';

type GameFinderSectionProps = {
  callType: 'home' | 'bc';
};
const GameFinderSection: React.FC<GameFinderSectionProps> = ({ callType }) => {
  return (
    <>
      <HomeSection
        content={
          <StyledCenterBox>
            <Typography variant="subtitle1">
              {callType === 'home'
                ? 'Who’s showing it? We’ve got the answer'
                : 'Searching for a specific game?'}
            </Typography>{' '}
            <br />
            <a href="/gamefinder">
              <Button variant="outlined" color="secondary">
                {callType === 'home'
                  ? 'Discover your Game'
                  : 'Go to GameFinder'}
              </Button>
            </a>
          </StyledCenterBox>
        }
        title={
          <>
            {callType === 'home' ? (
              <>
                <SportsSoccerIcon color="primary" />
                Game finder
              </>
            ) : (
              <></>
            )}
          </>
        }
        buttonTitle="Gamefinder"
        linkTo="/gamefinder"
      />
    </>
  );
};
export default GameFinderSection;
